import type { RfqPackage, RfqProject, SupplierOrg, VendorCapability, VendorWorkType } from '../types';

export const DEFAULT_VENDOR_CAPABILITIES: VendorCapability[] = ['timber'];

export function normalizeSupplierOrg(org: SupplierOrg): SupplierOrg {
  const caps = org.capabilities?.length ? org.capabilities : DEFAULT_VENDOR_CAPABILITIES;
  return { ...org, capabilities: caps };
}

export function orgHasCapability(org: SupplierOrg | undefined | null, cap: VendorCapability): boolean {
  if (!org) return false;
  const caps = org.capabilities?.length ? org.capabilities : DEFAULT_VENDOR_CAPABILITIES;
  return caps.includes(cap);
}

export function normalizeWorkType(workType?: VendorWorkType | null): VendorWorkType {
  if (workType === 'cnc_quote') return 'cnc_quote';
  if (workType === 'other_quote') return 'other_quote';
  return 'timber_rfq';
}

export function normalizeRfqProject(project: RfqProject): RfqProject {
  return { ...project, workType: normalizeWorkType(project.workType) };
}

export function normalizeRfqPackage(pkg: RfqPackage): RfqPackage {
  return { ...pkg, workType: normalizeWorkType(pkg.workType) };
}

export function workTypeLabel(workType?: VendorWorkType | null): string {
  const wt = normalizeWorkType(workType);
  if (wt === 'cnc_quote') return 'CNC Quote';
  if (wt === 'other_quote') return 'Other Quotes';
  return 'Timber RFQ';
}

export function capabilityLabel(cap: VendorCapability): string {
  return cap === 'cnc' ? 'CNC' : 'Timber';
}

export function rfqStatusLabel(status: RfqProject['status']): string {
  switch (status) {
    case 'invited':
      return 'Invited';
    case 'active':
      return 'Reviewing';
    case 'quoted':
      return 'Quoted';
    case 'closed':
      return 'Closed';
    default:
      return status;
  }
}

export const TIMBER_VENDOR_CHECKLIST = [
  'Species list and quantities match the published CSV/PDF',
  'Quote includes delivery location and lead time',
  'Submit quote as PDF or CSV',
  'Mark "Not bidding" if you cannot quote this package',
];

export const CNC_VENDOR_CHECKLIST = [
  'Review attached DXF/drawing files before quoting',
  'Quote structure: flat fee + $/bdft × board feet',
  'Include lead time in weeks and shipping assumptions',
  'Optional: attach a formal quote PDF with your submission',
];
